import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ProgramService } from 'src/app/core/services/api/program.service';
import { Category } from 'src/app/core/contracts/models/category';
import { CategoryService } from 'src/app/core/services/api/category.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PlatformService } from '../../../core/services/api/platform.service';
import { Swal2 } from 'src/app/core/utils/swal2.util';
import { Program } from 'src/app/core/contracts/models/programa.model';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { ProgramPlatform } from 'src/app/core/contracts/models/program-platform';
import Swal from 'sweetalert2';
import { AsignarProgramasLinkComponent } from '../link/asignar-programas-link.component';
import { CategoryFormComponent } from 'src/app/pages/maintenance/category/form/category-form.component';
@Component({
    selector: 'app-asignar-programas-form',
    templateUrl: './asignar-programas-form.component.html',
    styleUrls: ['./asignar-programas-form.component.scss']
})
export class AsignarProgramasFormComponent implements OnInit {
    public loading: boolean = false;
    @Input() id: number;
    myForm = this.formBuilder.group({
        name: new FormControl<string | null>(null, [Validators.required]),
        description: new FormControl<string | null>(null),
        categories: new FormControl<Array<any> | null>(null),
        periodicidad: new FormControl<Array<any> | null>(null),
        filterC: new FormControl<string | null>(null),
    });

    program: Program = {
        id: null,
        medio_id: null,
        nombre: null,
        periodicidad: null,
        descripcion: null,
        categorias: null
    }

    programs: Program[] = [];
    weekdays: any[] = [];

    title = 'Agregar programa';

    categories: Category[] = [];
    selectCategories$: Observable<Category[]>;

    platforms = [];

    isLoading = true;
    dataForm: ProgramPlatform = {
        id: null,
        programa_id: null,
        idMedioPlataforma: null,
        valor: null,
        alcance: null
    }

    rows: ProgramPlatform[] = [];

    /** Al crear: plataformas en la lista local; al editar: las ya guardadas */
    get hasPlatforms(): boolean {
        return this.rows.length > 0;
    }

    addPermission = this.auth.isPermit('medio.programa-plataforma.add');
    editPermission = this.auth.isPermit('medio.programa-plataforma.edit');
    deletePermission = this.auth.isPermit('medio.programa-plataforma.delete');

    messages = { emptyMessage: 'No hay información para mostrar.' };


    constructor(
        public dialog: MatDialog,
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<AsignarProgramasFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { row: any, id: number },
        private programService: ProgramService,
        private categoryService: CategoryService,
        private platformService: PlatformService,
        private auth: AuthService,
        private swal: Swal2
    ) {
        if (data.row) {
            this.title = 'Editar programa';
        }
    }

    ngOnInit(): void {
        // console.log(this.data.id);
        // console.log(this.data.row);

        this.categoryService.legacyGetAll().subscribe((response: any) => {
            const { categorias } = response;
            this.categories = categorias;
            if (this.data.row) {
                this.programService.getId(this.data.row.id).subscribe((response: Program) => {
                    // console.log('response', response);
                    this.id = response.id
                    this.myForm.controls.name.setValue(response.nombre);
                    this.myForm.controls.description.setValue(response.descripcion);
                    this.myForm.controls.categories.setValue(response.categorias);
                    this.weekdays = response.periodicidad ? response.periodicidad.split(',') : [];
                    this.myForm.controls.periodicidad.setValue(this.weekdays);
                    this.getAll();
                    // this.loadPlatforms();
                });
            } else {
                // this.loadPlatforms();
                this.isLoading = false;
            }
        });

        this.selectCategories$ = this.myForm.controls.categories.valueChanges.pipe(
            map(plats => {
                if (plats) {
                    return this.categories.filter(pl => plats.includes(pl.id));
                } else {
                    return [];
                }
            })
        )

        // this.platformService.getListByMedio(this.data.id).subscribe((response: any) => {
        //     const {medioPlataformas} = response;
        //     this.platforms = medioPlataformas;
        // });

    }

    getAll() {
        this.programService.getAllProgramaPlataformas(this.data.row.id).subscribe((response: any) => { //getAllProgramaPlataformas
            this.rows = response.data.map(row => ({
                ...row,
                alcance: row.alcance || 0 // Aseguramos que siempre haya un valor
            }));
            this.isLoading = false;
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 200);
        });
    }

    loadPlatforms() {
        this.platformService.getListByMedio(this.data.id).subscribe((response: any) => {
            const { medioPlataformas } = response;
            if (this.data.row && this.data.row.programa_plataformas) {
                const assignedPlatforms = this.data.row.programa_plataformas.map(pp => ({
                    medio_plat: pp.medio_plat,
                    medio_plat_clas: pp.medio_plat_clas,
                    medio_plat_valor: pp.medio_plat_valor
                }));

                this.platforms = medioPlataformas.map(mp => {
                    const isAssigned = assignedPlatforms.some(ap =>
                        ap.medio_plat === mp.plataforma_clasificacion.plataforma.descripcion &&
                        ap.medio_plat_clas === mp.plataforma_clasificacion.descripcion &&
                        ap.medio_plat_valor === mp.valor
                    );
                    return {
                        ...mp,
                        check: isAssigned
                    };
                });
            } else {
                this.platforms = medioPlataformas.map(mp => ({
                    ...mp,
                    check: false
                }));
            }
        });
    }

    edit(row: ProgramPlatform) {
        this.openDialog(row);
    }

    openDialog(row?: any) {
        // console.log(this.id);

        // Programa nuevo: las plataformas se acumulan en la lista y se guardan junto con el programa
        if (!this.data.row) {
            this.openLocalDialog(row);
            return;
        }

        const dialogRef = this.dialog.open(AsignarProgramasLinkComponent, {
            data: { row, id: this.id, medio_id: this.data.id }, // 
            width: '600px'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getAll();
            }
        });
    }

    private openLocalDialog(pending?: any) {
        const dialogRef = this.dialog.open(AsignarProgramasLinkComponent, {
            data: {
                local: true,
                pending,
                medio_id: this.data.id,
                assignedIds: this.rows.filter(r => r !== pending).map(r => r.idMedioPlataforma),
            },
            width: '600px'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (!result) return;
            this.rows = pending
                ? this.rows.map(r => r === pending ? result : r)
                : [...this.rows, result];
        });
    }

    removePlatform(row: any) {
        // Programa nuevo: solo se quita de la lista local
        if (!this.data.row) {
            this.rows = this.rows.filter(r => r !== row);
            return;
        }
        this.delete(row.id);
    }

    onSubmit() {
        this.program = {
            medio_id: this.data.id,
            nombre: this.myForm.controls.name.value,
            descripcion: this.myForm.controls.description.value,
            periodicidad: this.myForm.controls.periodicidad.value ? this.myForm.controls.periodicidad.value.join() : '',
            categorias: this.myForm.controls.categories.value,
        }
        let observable: Observable<any> | undefined = undefined;
        if (this.data.row) {
            this.program.id = this.data.row.id;
            this.program.mediosPlataformas = this.platforms.filter(pt => pt.check).map(pt => pt.id)
            observable = this.programService.update(this.program)
        } else {
            this.program.mediosPlataformas = this.platforms.filter(pt => pt.check).map(pt => pt.id)
            this.program.plataformas = this.rows.map((r: any) => ({
                idMedioPlataforma: r.idMedioPlataforma,
                valor: r.valor,
                alcance: r.alcance,
            }));
            observable = this.programService.create(this.program)
        }
        this.loading = true;
        observable.subscribe((response: any) => {
            this.dialogRef.close(response);
            this.loading = false;
            this.swal.showToast(response.message, 'success');
        }, error => {
            if (error.status === 400) {
                this.error(error);
            } else if (error.status === 403) {
                this.swal.showToast(error.error.message, 'error');
            }
            this.loading = false;
        });
    }

    remove(id): void {
        let preSelects = [...this.myForm.controls.categories.value];

        const index = preSelects.indexOf(id);
        if (index != -1) {
            const filteredOptions = [...preSelects].filter(op => op != id);
            this.myForm.controls.categories.patchValue(filteredOptions);
        }
    }

    error(error) {
        if (error.error.errors.nombre) {
            this.swal.showToast(error.error.errors.nombre[0], 'error');
            return;
        }
        // Errores de las plataformas enviadas junto con el programa (plataformas.0.idMedioPlataforma, ...)
        const platformError = Object.keys(error.error.errors).find(key => key.startsWith('plataformas'));
        if (platformError) {
            this.swal.showToast(error.error.errors[platformError][0], 'error');
        }
    }

    delete(id: number) {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "¡No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#645CAA',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.programService.deleteProgramaPlataformas(id).subscribe({
                    next: (response: any) => {
                        Swal.fire({
                            title: 'Eliminado',
                            text: 'El programa se ha eliminado correctamente',
                            icon: 'success',
                            confirmButtonColor: '#645CAA',
                            confirmButtonText: 'OK'
                        }).then(() => {
                            this.getAll();
                        });
                    },
                    error: (error) => {
                        Swal.fire({
                            title: 'Error',
                            text: error.error.message || 'Ha ocurrido un error',
                            icon: 'error',
                            confirmButtonColor: '#645CAA',
                            confirmButtonText: 'OK'
                        });
                    }
                });
            }
        });
    }

    addCategoria(row?) {
        const dialogRef = this.dialog.open(CategoryFormComponent, {
            data: row,
            width: '500px'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.categoria) {
                const newCategory = result.categoria;
                this.categories.push(newCategory);
                const selected = this.myForm.controls.categories.value || [];
                if (!selected.includes(newCategory.id)) {
                    this.myForm.controls.categories.setValue([...selected, newCategory.id]);
                }
                this.myForm.controls.filterC.setValue(null);
            }
        });
    }
}